import BaseApi from '@/api/Base/BaseApi'
import {
  InviteMembersPayload,
  SimpleInvitationInfo,
  InvitationInfo,
  RemoveMemberPayload,
  InviteTeamsMembersPayload
} from '@/api/Invitation/types'
import { Workspace } from '@/api/Workspace/types'
import { UserInfo } from '@/api/User/types'

export default class InvitationApi extends BaseApi {
  getInvitationInfo(invitationCode: string) {
    return this.agent.get<SimpleInvitationInfo>(`/invitation/${invitationCode}/info`)
  }

  acceptInvitation(invitationCode: string) {
    return this.agent.post<Workspace>('/invitation/workspace/accept', { invitationCode })
  }

  rescindInvitation(invitationId: string) {
    return this.agent.delete<InvitationInfo>(`/invitation/${invitationId}/workspace/rescind`)
  }

  inviteUsersToWorkspace(payload: InviteMembersPayload) {
    return this.agent.post('/invitation/workspace/members', payload)
  }

  resendInvitation(invitationId: string) {
    return this.agent.post(`/invitation/${invitationId}/workspace/resend`)
  }

  getInvitedUsersToWorkspace(workspaceId: string) {
    return this.agent.get<InvitationInfo[]>(`/invitation/workspace/${workspaceId}/list`)
  }

  removeMember(payload: RemoveMemberPayload) {
    const { workspaceId, userId } = payload
    return this.agent.delete(`/invitation/workspace/${workspaceId}/member/${userId}`)
  }

  // teams
  getInvitableUsers() {
    return this.agent.get<UserInfo[]>('/invitation/teams/invitable-user-list')
  }

  getTeamsInvitedMemberList(workspaceId: string) {
    return this.agent.get<InvitationInfo[]>(`/invitation/teams/workspace/${workspaceId}/member-list`)
  }

  inviteTeamsMembersToWorkspace(payload: InviteTeamsMembersPayload) {
    return this.agent.post('/invitation/teams/workspace/members', payload)
  }
}
